import React from 'react';
import { inject, observer } from 'mobx-react';
import { Trail, Spring, animated, config } from 'react-spring';

import Container from './Container';
import Header from './Header';
import NoOffers from './NoOffers';
import Body from './Body';
import Offer from './Offer';
import { startAnimation, endAnimation } from 'js/config/style';

export default inject('page')(
  observer(({ page }) => {
    const offers = page.offers;
    return (
      <Spring native from={startAnimation} to={endAnimation} config={config.gentle}>
        {animation => (
          <animated.div style={animation}>
            <Container>
              <Header>PURCHASE OFFERS</Header>
              {offers.length ? (
                <Body>
                  <Trail native items={offers} from={{ opacity: 0 }} to={{ opacity: 1 }} keys={offer => offer.uid}>
                    {offer => animation => (
                      <animated.div style={animation}>
                        <Offer offer={offer} />
                      </animated.div>
                    )}
                  </Trail>
                </Body>
              ) : (
                <NoOffers />
              )}
            </Container>
          </animated.div>
        )}
      </Spring>
    );
  }),
);
